/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import type { FC } from "react";

type Props = {
  alt: string;
  aspectRatio: number;
  src: string;
};

export const AspectRatioImage: FC<Props> = ({ alt, aspectRatio, src }) => {
  const classes = styles({ aspectRatio });

  return <img src={src} alt={alt} css={classes.image} />;
};

const styles = ({ aspectRatio }: Pick<Props, "aspectRatio">) => ({
  image: css`
    display: block;
    width: 100%;
    aspect-ratio: ${aspectRatio};
    object-fit: cover;
  `,
});
